export default "{\n    \"emptyStateLabel\": \"No se encontraron resultados\",\n    \"scrollLabel\": \"desplazar\"\n}\n"